import { NO_CUSOMIZED_PARAM } from './consts/loginCustomizedParams';
import { BRAND_MAKER_COLOR, BUSINESS_CARDS_MAKER_COLOR, LOGO_BUILDER_COLOR } from './consts/LoginColors';
export default class WixLoginUtils {
    static setCustomizedParam(customized) {
        WixLoginUtils.customizedParam = customized;
    }
    static getLoginUrl(returnUrl, cancelUrl, lang, appName) {
        return WixLoginUtils.getUsersUrl(returnUrl, cancelUrl, 'signin', lang, appName);
    }
    static getSignUpUrl(returnUrl, cancelUrl, lang, appName) {
        return WixLoginUtils.getUsersUrl(returnUrl, cancelUrl, 'signup', lang, appName);
    }
    static getLogOutUrl(returnUrl) {
        const encodedUri = encodeURIComponent(returnUrl);
        return `https://wix.com/signout?redirectTo=${encodedUri}`;
    }
    static getUrlLoginColorByApp(appName) {
        let color = LOGO_BUILDER_COLOR;
        if (appName === 'BUSINESS_CARDS_MAKER') {
            color = BUSINESS_CARDS_MAKER_COLOR;
        }
        else if (appName === 'BRAND_MAKER') {
            color = BRAND_MAKER_COLOR;
        }
        return color;
    }
    static getUsersUrl(returnUrl, cancelUrl = 'http%3A%2F%2Fwww.wix.com%2F', type, lang, appName = 'LOGO') {
        const encodedUri = encodeURIComponent(returnUrl);
        const encodedCancelUri = encodeURIComponent(cancelUrl);
        const baseUrl = WixLoginUtils.loginBaseUrl;
        const color = WixLoginUtils.getUrlLoginColorByApp(appName);
        const params = {
            color,
            loginDialogContext: type,
            sendEmail: 'false',
            referralInfo: 'HEADER',
            redirectTo: encodedUri,
            postSignUp: encodedUri,
            originUrl: encodedCancelUri
        };
        if (lang) {
            params.overrideLocale = lang;
        }
        if (WixLoginUtils.customizedParam !== NO_CUSOMIZED_PARAM) {
            params.customized = WixLoginUtils.customizedParam;
        }
        const urlParams = Object.keys(params).map(key => key + '=' + params[key]);
        const url = `${baseUrl}?${urlParams.join('&')}`;
        return url;
    }
}
WixLoginUtils.loginBaseUrl = 'https://users.wix.com/logo/signin';
//# sourceMappingURL=WixLoginUtils.js.map